import { render } from "./Menu.vue?vue&type=template&id=615df590&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=615df590&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-615df590"

export default script